import type {
  AssistantAccessArea,
  AssistantReplyLength,
  AssistantTone,
} from '@/api/assistantConfiguration/assistantConfigurationApi.types';
import type { IconName } from '@/components/common/Icon';

export const ASSISTANT_TONES: AssistantTone[] = ['friendly', 'professional', 'formal'];

export const ASSISTANT_REPLY_LENGTHS: AssistantReplyLength[] = ['brief', 'balanced', 'detailed'];

export interface AssistantAccessAreaDefinition {
  area: AssistantAccessArea;
  iconName: IconName;
}

export const ASSISTANT_ACCESS_AREAS: AssistantAccessAreaDefinition[] = [
  { area: 'workspace_setup', iconName: 'Settings' },
  { area: 'integrations', iconName: 'Link' },
  { area: 'schedule', iconName: 'Calendar' },
  { area: 'patient_records', iconName: 'PawPrint' },
  { area: 'clinical_notes', iconName: 'FileText' },
];

export function toggleAccessArea(
  areas: AssistantAccessArea[],
  area: AssistantAccessArea
): AssistantAccessArea[] {
  if (areas.includes(area)) {
    return areas.filter(function keepOthers(existingArea) {
      return existingArea !== area;
    });
  }
  return ASSISTANT_ACCESS_AREAS.map(function readArea(definition) {
    return definition.area;
  }).filter(function keepSelected(candidateArea) {
    return candidateArea === area || areas.includes(candidateArea);
  });
}
